import { splitWithBraces, trimBraces } from '../inboundUtils';
import { lobbyRoomParser } from './utils/lobbyRoomInboundUtils';
function lobbyRoomsParser(str) {
    const lobbyRoomStrs = splitWithBraces(trimBraces(str));
    if (!lobbyRoomStrs[0].length) {
        // first room data is an empty string, so no rooms exist
        return [];
    }
    return lobbyRoomStrs.map(lobbyRoomParser);
}
export const ADD_LOBBY_ROOMS_PAYLOAD_DEFINITION = {
    shouldSplitWithBraces: true,
    definitionParts: [{ name: 'lobbyRooms', parser: lobbyRoomsParser }]
};
